import * as React from "react";

/* eslint-disable react/prop-types */

import { StatelessAnzsicCodeInput } from "./StatelessAnzsicCodeInput";
import { useAnzsicCodes } from "./useAnzsicCodes";

export function AnzsicCodeInput(props) {
  const [codes, { loading }] = useAnzsicCodes(props?.year);
  return <StatelessAnzsicCodeInput {...props} codes={codes} loading={loading} />;
}
